<template>
  <div class="font-display-styles-wrapper" ref="tableContainerRef">
    <div class="font-display-styles-grid">
      <agGrid
        :getRowId="params => params.data.id"
        :rowData="rowData"
        :columnDefs="colDefs"
        :isPagination="false"
        :enableCellTextSelection="true"
        :rowHeight="72"
      >
      </agGrid>
    </div>
  </div>
</template>
